<template>
    <div>
        <div v-if="this.$store.state.isConfig && this.$store.state.isLoaded">
            <Top></Top>
            <Header></Header>
            <Banner></Banner>
            <Article></Article>
            <Video></Video>
            <Footer></Footer>
        </div>
        <div class="loading-box" v-if="!this.$store.state.isLoaded">
            <van-loading  vertical>加载中...</van-loading>
        </div>
        <div class="none" v-if="!this.$store.state.isConfig && this.$store.state.isLoaded">
            <h2>404 Not Found</h2>
            <p>页面未找到</p>
        </div>
    </div>
</template>

<script>
import Top from '@/components/mjwy/home/Top'
import Header from '@/components/mjwy/home/Header'
import Banner from '@/components/mjwy/home/Banner'
import Article from '@/components/mjwy/home/Article'
import Video from '@/components/mjwy/home/Video'
import Footer from '@/components/mjwy/home/Footer'

export default {
    name: 'Home',
    components: {
        Top,
        Header,
        Banner,
        Article,
        Video,
        Footer
    },
}
</script>

<style scoped>
.loading-box{
    height: 100vh;
    width: 100%;
    text-align: center;
    padding-top: 40px;
    font-size: 13px;
    color: #f9fde4;
}
.none{
    text-align: center;
    color:#ddd;
}
</style>


// WEBPACK FOOTER //
// src/components/mjwy/Home.vue